"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function eq(a, b) {
    return a === b;
}
var DeQueue = /** @class */ (function () {
    function DeQueue(cmp) {
        this.head = null;
        this.tail = null;
        this.cmp = typeof cmp === 'undefined' ? eq : cmp;
    }
    DeQueue.prototype.empty = function () {
        return this.head === null && this.tail === null;
    };
    DeQueue.prototype.pushFront = function (v) {
        if (this.empty()) {
            return this.init(v);
        }
        var node = {
            next: this.head,
            last: null,
            value: v,
        };
        this.head.last = node;
        this.head = node;
    };
    DeQueue.prototype.pushBack = function (v) {
        if (this.empty()) {
            return this.init(v);
        }
        var node = {
            last: this.tail,
            next: null,
            value: v,
        };
        this.tail.next = node;
        this.tail = node;
    };
    DeQueue.prototype.peekFront = function () {
        if (this.head !== null) {
            return this.head.value;
        }
        return undefined;
    };
    DeQueue.prototype.peekBack = function () {
        if (this.tail !== null) {
            return this.tail.value;
        }
        return undefined;
    };
    DeQueue.prototype.popFront = function () {
        if (this.head !== null) {
            var h = this.head;
            if (this.head === this.tail) {
                this.head = null;
                this.tail = null;
            }
            else {
                this.head = this.head.next;
            }
            return h.value;
        }
        return undefined;
    };
    DeQueue.prototype.popBack = function () {
        if (this.tail !== null) {
            var t = this.tail;
            if (this.tail === this.head) {
                this.head = null;
                this.tail = null;
            }
            else {
                this.tail = this.tail.last;
            }
            return t.value;
        }
        return undefined;
    };
    DeQueue.prototype.init = function (v) {
        var node = {
            value: v,
            next: null,
            last: null,
        };
        this.head = node;
        this.tail = node;
    };
    DeQueue.prototype.erase = function (v) {
        var node = this.head;
        var last = null;
        while (node !== null) {
            if (this.cmp(v, node.value)) {
                if (node === this.head) {
                    this.head = this.head.next;
                }
                if (node === this.tail) {
                    this.tail = this.tail.last;
                }
                // If we're not at the last node,
                if (node.next !== null) {
                    node.next.last = last;
                }
                // If we're not at the first not.
                if (last !== null) {
                    last.next = node.next;
                }
            }
            else {
                last = node;
            }
            node = node.next;
        }
    };
    DeQueue.prototype.exists = function (v) {
        var node = this.head;
        while (node !== null) {
            if (this.cmp(v, node.value)) {
                return true;
            }
            node = node.next;
        }
        return false;
    };
    DeQueue.prototype.size = function () {
        var size = 0;
        var node = this.head;
        while (node !== null) {
            size++;
            node = node.next;
        }
        return size;
    };
    return DeQueue;
}());
exports.DeQueue = DeQueue;
var LRU = /** @class */ (function () {
    function LRU(size, cmp) {
        this.size = size;
        this.cache = new Map();
        this.touched = new DeQueue();
        this.hit = 0;
        this.miss = 0;
    }
    LRU.prototype.get = function (k) {
        var v = this.cache.get(k);
        if (typeof v !== 'undefined') {
            this.hit++;
            this.touched.erase(k);
            this.touched.pushFront(k);
        }
        else {
            this.miss++;
        }
        return v;
    };
    LRU.prototype.set = function (k, v) {
        if (this.atCapacity()) {
            this.evict();
        }
        if (this.cache.has(k)) {
            this.touched.erase(k);
            this.cache.delete(k);
        }
        this.touched.pushFront(k);
        this.cache.set(k, v);
    };
    LRU.prototype.has = function (k) {
        return this.cache.has(k);
    };
    LRU.prototype.getHits = function () {
        return this.hit;
    };
    LRU.prototype.used = function () {
        return this.cache.size;
    };
    LRU.prototype.evict = function () {
        var oldest = this.touched.popBack();
        if (typeof oldest !== 'undefined') {
            this.cache.delete(oldest);
        }
    };
    LRU.prototype.atCapacity = function () {
        return this.used() >= this.size;
    };
    return LRU;
}());
exports.LRU = LRU;
